<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row">
      <div id="page-header" class="col-lg-9 col-12">
        <div class="content-header row" *ngIf="contentHeader">
          <div class="content-header-left col-12 mb-2">
            <div class="row breadcrumbs-top">
              <div class="col-12">
                <h2 class="content-header-title mb-0">
                  {{ contentHeader.headerTitle | translate }}
                  <span class="font-medium-1">{{ formatLabel(selectedMonth) }} {{ selectedYear }}</span>
                </h2>
                <app-breadcrumb *ngIf="contentHeader.breadcrumb.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <core-card [actions]="[]">
      <div class="card-title w-100">
        <div [ngClass.xl]="'float-left row pl-1'" [ngClass.md]="'float-left row pl-1'">
          <!-- Cerca -->
          <input
            type="search"
            id="datatable-search-input"
            [placeholder]="'SEARCH' | translate"
            class="form-control"
            [ngClass.xl]="'w-fit d-inline-block'"
            [ngClass.md]="'w-fit d-inline-block'"
            [ngClass.sm]="'mb-075'"
            [(ngModel)]="searchKeyword"
            (ngModelChange)="reportsFilterList()"
          />
          <!-- Filtro stato -->
          <select [(ngModel)]="searchStatus" (ngModelChange)="reportsFilterList()" class="form-control" [ngClass.xl]="'w-fit d-inline-block ml-1'" [ngClass.md]="'w-fit d-inline-block ml-1'">
            <option value="10" selected>{{ "STATE" | translate }}</option>
            <option value="0">{{ "NOT_SENDED" | translate }}</option>
            <option value="1">{{ "SENDED" | translate }}</option>
            <option value="2">{{ "SIGNATURE_TO_APPROVE" | translate }}</option>
            <option value="3">{{ "COMPLETED" | translate }}</option>
          </select>
        </div>
        <!-- Gestione paginazione -->
        <div class="float-right ml-1" [ngClass.xl]="'d-flex'" [ngClass.md]="'d-none'" [ngClass.sm]="'d-none'">
          <div class="w-fit">
            <label for="pagination" class="d-flex align-items-center"
            >{{ "SHOW" | translate }}
              <select class="form-control ml-075 pr-3" (change)="reportsFilterList(); updateTableLimit($event)" id="pagination">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </label>
          </div>
        </div>
        <!-- Filtro per mese ed anno -->
        <div [ngClass.xl]="'float-right'" [ngClass.md]="'float-right'" [ngClass.sm]="'mt-075'">
          <div class="d-flex">
            <label for="monthYear" class="mb-0" [ngClass.sm]="'flex-basis-66'">
              <select [(ngModel)]="selectedMonth" (ngModelChange)="loadRefunds()" id="monthYear" class="form-control pr-3 text-capitalize">
                <option selected disabled value="all">{{ "MONTH" | translate }}</option>
                <option *ngFor="let month of availableMonths" [value]="month" [label]="formatLabel(month)">{{ month }}</option>
              </select>
            </label>
            <label for="years" class="mb-0 ml-1" [ngClass.sm]="'flex-basis-33'">
              <select id="years" [(ngModel)]="selectedYear" (change)="loadRefunds()" class="form-control pr-3">
                <option selected disabled value="all">{{ "YEAR" | translate }}</option>
                <option *ngFor="let year of availableYears">{{ year }}</option>
              </select>
            </label>
          </div>
        </div>
        <div class="clearboth"></div>
      </div>
      <!-- Tabella -->
      <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="refunds"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isSmallDesktop ? 90 : 60"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" width="200" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <span>{{ row.complete_name }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'REFUND' | translate }}" prop="bonus" width="170" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.bonus | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'TRANSFERS' | translate }}" width="170" [sortable]="true" prop="bonus_extra">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.bonus_extra | currency: 'EUR' }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'EXTRA_HOURS' | translate }}" width="70" [sortable]="true" prop="extra_km">
            <ng-template ngx-datatable-cell-template let-row="row"> {{ row.extra_km }}h</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'STATE' | translate }}" prop="enabled_label" width="90" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-secondary" *ngIf="row.document_status === 0">{{ row.enabled_label }}</span>
              <span class="badge badge-info" *ngIf="row.document_status === 1">{{ row.enabled_label }}</span>
              <span class="badge badge-warning" *ngIf="row.document_status === 2">{{ row.enabled_label }}</span>
              <span class="badge badge-success" *ngIf="row.document_status === 3">{{ row.enabled_label }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <a class="bg-transparent border-0 text-secondary pr-1 cursor-pointer" *ngIf="row.document && row.document.document_id" target="_blank"
                   (click)="viewDocument(row)" [ngbTooltip]="'VIEW' | translate" placement="left">
                  <i class="text-primary" [data-feather]="'eye'" size="19"></i>
                </a>
                <button class="bg-transparent border-0 text-secondary pr-1 cursor-pointer" has_capability="refunds_kilometers_generate_document"
                        [disabled]="row.extra_km && row.extra_km > 0 && (!row.bonus_extra || row.bonus_extra === 0 || row.bonus_extra === '0,00' || row.bonus_extra === '0.00')"
                        (click)="generateDocument(row.hash)" [ngbTooltip]="'GENERATE_DOCUMENT' | translate" placement="left">
                  <i [data-feather]="'tool'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <!--mobile - tablet-->
      <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [limit]="tableLimit"
          [footerHeight]="60"
          [rows]="refunds"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="200"
        >
          <ngx-datatable-column name="{{ 'FIRSTNAME' | translate }}" prop="complete_name" width="200" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row" [ngClass.md]="'list-item-mobile'">
                <div class="col-12 d-flex" [ngClass.md]="'pl-0'">
                  <span>{{ row.complete_name }}</span>
                </div>
                <div class="col-12 d-flex align-items-center" [ngClass.md]="'pl-0'">
                  <span class="font-weight-bold">{{ "REFUND" | translate }}: </span>
                  <span *ngIf="row.bonus">{{ row.bonus | currency: 'EUR' }}</span>
                </div>
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <div class="d-flex align-items-center">
                    <span class="font-weight-bold">{{ "TRANSFERS" | translate }}: </span>
                    <span *ngIf="row.bonus_extra">{{ row.bonus_extra | currency: 'EUR' }} €</span>
                  </div>
                </div>
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <span class="font-weight-bold">{{ "EXTRA_HOURS" | translate }}: </span>
                  <span>{{ row.extra_km }}h</span>
                </div>
                <div class="col-12" [ngClass.md]="'pl-0'">
                  <span class="badge badge-secondary" *ngIf="row.document_status === 0">{{ row.enabled_label }}</span>
                  <span class="badge badge-info" *ngIf="row.document_status === 1">{{ row.enabled_label }}</span>
                  <span class="badge badge-warning" *ngIf="row.document_status === 2">{{ row.enabled_label }}</span>
                  <span class="badge badge-success" *ngIf="row.document_status === 3">{{ row.enabled_label }}</span>
                </div>
                <div class="col-12 d-flex align-items-center justify-content-end" [ngClass.md]="'pr-2'">
                  <a class="btn btn-outline-primary text-primary cursor-pointer mr-1" *ngIf="row.document && row.document.document_id" target="_blank"
                     (click)="viewDocument(row)">{{'VIEW' | translate}} </a>
                  <button class="btn btn-outline-primary cursor-pointer" has_capability="refunds_kilometers_generate_document"
                          [disabled]="row.extra_km && row.extra_km > 0 && (!row.bonus_extra || row.bonus_extra === 0 || row.bonus_extra === '0,00' || row.bonus_extra === '0.00')"
                          (click)="generateDocument(row.hash)">{{'GENERATE_DOCUMENT' | translate}}</button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </core-card>
  </div>
</div>
